export class LotCodeAttribute {
    lotCode: string;
    constructor(lotCode: string) {
         this.lotCode =lotCode;
         }
}